import React, { useState } from 'react';
import './ConfirmModal.css'; // Reusing ConfirmModal styles for consistency

const InviteCodeModal = ({ isOpen, onClose, onConfirm, loading }) => {
  const [code, setCode] = useState('');

  if (!isOpen) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    if (code.trim()) {
      onConfirm(code.trim());
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content" style={{padding: '30px'}}>
        <h2>Enter Invite Code</h2>
        <p>This tournament is invite-only. Please enter your code below.</p>
        
        <form onSubmit={handleSubmit}>
            <input
                type="text"
                value={code}
                onChange={(e) => setCode(e.target.value)}
                placeholder="Enter 10-character code"
                className="modal-input"
                style={{
                    width: '100%',
                    padding: '10px',
                    margin: '15px 0',
                    backgroundColor: '#333',
                    border: '1px solid #555',
                    color: 'white',
                    borderRadius: '4px',
                    fontSize: '16px',
                    outline: 'none'
                }}
                onFocus={(e) => e.target.style.border = '1px solid var(--accent-primary)'}
                onBlur={(e) => e.target.style.border = '1px solid #555'}
                autoFocus
            />
            
            <div className="modal-actions">
            <button 
                type="button" 
                onClick={onClose} 
                className="modal-btn cancel-btn"
                disabled={loading}
            >
                Cancel
            </button>
            <button 
                type="submit" 
                className="modal-btn confirm-btn"
                disabled={!code.trim() || loading}
            >
                {loading ? 'Joining...' : 'Join Tournament'}
            </button>
            </div>
        </form>
      </div>
    </div>
  );
};

export default InviteCodeModal;
